import React, { Component } from 'react';
import { Button, Modal, Form, Spin, Tabs } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actions } from "store";

import MainFieldSet from './MainFieldSet';
import ParametersFieldSet from './ParametersFieldSet';
import ContactFieldSet from './ContactFieldSet';
import ServiceFieldSet from './ServiceFieldSet';
import TariffFieldSet from './TariffFieldSet';
import GeoFieldSet from './GeoFieldSet';


class ProfileForm extends Component {
    state = {
        id: null,
        photos: [],
        show: false,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { editObject, showEditForm } = nextProps.profile;

        let nextState = {};

        if (showEditForm !== prevState.show) {
            nextState = {
                id: null,
                photos: [],
                show: showEditForm,
            };
        }

        if (editObject && editObject.id !== prevState.id) {
            nextState.id = editObject.id;
            //nextState.photos = editObject.photos;

            let moderationData = editObject && (editObject.moderation_data || {});
            nextState.photos = moderationData.photos || editObject.photos;
        }
        return nextState;
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const { actions, profile, agencyId } = this.props;
                const instance = profile.editObject;

                let data = Object.assign({}, values, { photos: this.state.photos });
                if (instance && instance.id) {
                    data.id = instance.id;
                } else if (agencyId) {
                    data.agency = agencyId;
                }
                console.log(data);
                actions.profileUpdate({ data });
            }
        });
    };

    close = () => {
        const { actions } = this.props;
        actions.profileShowEditForm({ show: false });
    };

    handlePhotosChange = (photos) => {
        this.setState({
            photos: photos,
        })
    };

    render() {
        const { form, profile, countryId, cityId, auth_token } = this.props;
        const { showEditForm, updateStatus } = profile;

        const error = updateStatus.error || {};
        const errorData = error.data || {};

        const isLoading = updateStatus.isLoading;

        return (
            <Modal
                width={960}
                visible={showEditForm}
                title="Редактирование анкеты"
                onCancel={this.close}
                maskClosable={false}
                destroyOnClose={true}
                footer={[
                    <Button key="cancel" onClick={this.close} disabled={isLoading}>Отмена</Button>,
                    <Button key="submit" type="primary" loading={isLoading} onClick={this.handleSubmit}>
                        Сохранить
                    </Button>,
                ]}
            >
                <Spin spinning={isLoading}>
                    <Form onSubmit={this.handleSubmit}>
                        {errorData.non_field_errors &&
                        <div className="form-error">{errorData.non_field_errors}</div>}

                        <Tabs className="tabs">
                            <Tabs.TabPane tab="Основное" key="detail">
                                <MainFieldSet profile={profile} form={form} onPhotoChange={this.handlePhotosChange}
                                              auth_token={auth_token}/>

                                <GeoFieldSet profile={profile} form={form} countryId={countryId} cityId={cityId}/>
                            </Tabs.TabPane>

                            <Tabs.TabPane tab="Параметры" key="parameters">
                                <ParametersFieldSet profile={profile} form={form}/>
                            </Tabs.TabPane>

                            <Tabs.TabPane tab="Контакты" key="contacts">
                                <ContactFieldSet profile={profile} form={form}/>
                            </Tabs.TabPane>

                            <Tabs.TabPane tab="Услуги" key="service">
                                <ServiceFieldSet profile={profile} form={form} />
                            </Tabs.TabPane>

                            <Tabs.TabPane tab="Тарифы" key="tariff">
                                <TariffFieldSet profile={profile} form={form}/>
                            </Tabs.TabPane>
                        </Tabs>
                    </Form>
                </Spin>
            </Modal>
        );
    }
}


const WrappedProfileForm = Form.create()(ProfileForm);

function mapStateToProps(state) {
    return {
        auth_token: state.auth.token,
        profile: state.profile,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({},
            actions.profile,
        ), dispatch),
        dispatch: dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WrappedProfileForm);

